import 'svelte/internal/disclose-version';

MapView[$.FILENAME] = 'src/components/MapView.svelte';

import * as $ from 'svelte/internal/client';
import { loadGoogleMaps } from "../lib/googleMaps.js";
import { restaurantUrl } from "../lib/routes.js";
import { formatLocation } from "../lib/format.js";

var root = $.add_locations($.from_html(`<p class="notice svelte-19wauhf">Loading map…</p>`), MapView[$.FILENAME], [[110, 4]]);
var root_1 = $.add_locations($.from_html(`<p class="notice svelte-19wauhf">Couldn't load the map. Try again in a moment.</p>`), MapView[$.FILENAME], [[112, 4]]);
var root_2 = $.add_locations($.from_html(`<p class="notice svelte-19wauhf">Map view isn't set up on this server yet.</p>`), MapView[$.FILENAME], [[114, 4]]);
var root_3 = $.add_locations($.from_html(`<p class="notice overlay svelte-19wauhf">None of these results have a mapped location yet.</p>`), MapView[$.FILENAME], [[116, 4]]);
var root_4 = $.add_locations($.from_html(`<div class="map-shell svelte-19wauhf"><div></div> <!></div>`), MapView[$.FILENAME], [[106, 0, [[107, 2]]]]);

const $$css = {
	hash: 'svelte-19wauhf',
	code: '\n  .map-shell.svelte-19wauhf { position: relative; }\n  .map-container.svelte-19wauhf {\n    width: 100%;\n    height: 520px;\n    border: 1px solid var(--line);\n    border-radius: var(--radius);\n    background: var(--card-soft);\n  }\n  .map-container.hidden.svelte-19wauhf { visibility: hidden; }\n  .notice.svelte-19wauhf {\n    color: var(--ink-soft);\n    font-size: 0.92rem;\n    padding: 20px;\n  }\n  .notice.svelte-19wauhf:not(.overlay) {\n    position: absolute;\n    inset: 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    text-align: center;\n    border: 1px solid var(--line);\n    border-radius: var(--radius);\n    background: var(--card-soft);\n  }\n  .notice.overlay.svelte-19wauhf {\n    position: absolute;\n    top: 12px;\n    left: 50%;\n    transform: translateX(-50%);\n    background: var(--card);\n    border: 1px solid var(--line);\n    border-radius: var(--radius-pill);\n    padding: 8px 16px;\n    box-shadow: var(--shadow-sm);\n  }\n\n  /* Rendered by the Google Maps InfoWindow outside this component\'s DOM, so it needs\n     unscoped rules to take effect. */\n  .map-info { font: inherit; max-width: 220px; }\n  .map-info strong { display: block; margin-bottom: 3px; font-size: 0.92rem; }\n  .map-info-meta { color: #666; font-size: 0.82rem; margin-bottom: 3px; }\n  .map-info-rating { font-size: 0.82rem; margin-bottom: 5px; }\n  .map-info a { font-size: 0.85rem; font-weight: 600; color: var(--accent); }\n\n/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */'
};

export default function MapView($$anchor, $$props) {
	$.check_target(new.target);
	$.push($$props, true, MapView);
	$.append_styles($$anchor, $$css);

	let items = $.prop($$props, 'items', 19, () => []),
		apiKey = $.prop($$props, 'apiKey', 3, null);

	let container = $.tag($.state(null), 'container');
	let status = $.tag($.state("loading" // loading | ready | error | unconfigured
	), 'status');
	let map = null;
	let infoWindow = null;
	let markers = [];
	const located = $.tag($.derived(() => items().filter((r) => $.equals(r.latitude, null, false) && $.equals(r.longitude, null, false))), 'located');

	$.user_effect(() => {
		if (!apiKey()) {
			$.set(status, "unconfigured");

			return;
		}

		let cancelled = false;

		loadGoogleMaps(apiKey()).then((maps) => {
			if (cancelled || !$.get(container)) return;

			map = new maps.Map($.get(container), {
				center: { lat: 40.85, lng: -74.02 },
				zoom: 11,
				streetViewControl: false,
				mapTypeControl: false,
				fullscreenControl: false
			});

			infoWindow = new maps.InfoWindow();
			$.set(status, "ready");
		}).catch(() => {
			if (!cancelled) $.set(status, "error");
		});

		return () => {
			cancelled = true;
		};
	});

	// Redraws markers whenever the plotted set changes, once the map exists.
	$.user_effect(() => {
		const rows = $.get(located);

		if ($.strict_equals($.get(status), "ready", false) || !map) return;

		const maps = window.google.maps;

		markers.forEach((m) => m.setMap(null));

		markers = rows.map((r) => {
			const marker = new maps.Marker({
				position: { lat: r.latitude, lng: r.longitude },
				map,
				title: r.name
			});

			marker.addListener("click", () => {
				infoWindow.setContent(markerContent(r));
				infoWindow.open({ map, anchor: marker });
			});

			return marker;
		});

		if ($.strict_equals(rows.length, 0)) return;

		if ($.strict_equals(rows.length, 1)) {
			map.setCenter({ lat: rows[0].latitude, lng: rows[0].longitude });
			map.setZoom(15);

			return;
		}

		const bounds = new maps.LatLngBounds();

		rows.forEach((r) => bounds.extend({ lat: r.latitude, lng: r.longitude }));
		map.fitBounds(bounds, 48);
	});

	function markerContent(r) {
		const rating = r.combined?.rating ?? (r.reviewCount > 0 ? r.ratingAverage : null);
		const wrap = document.createElement("div");

		wrap.className = "map-info";

		const name = document.createElement("strong");

		name.textContent = r.name;
		wrap.append(name);

		const meta = document.createElement("div");

		meta.className = "map-info-meta";
		meta.textContent = [r.cuisine, formatLocation(r)].filter(Boolean).join(" · ");
		wrap.append(meta);

		if (rating) {
			const ratingEl = document.createElement("div");

			ratingEl.className = "map-info-rating";
			ratingEl.textContent = `★ ${(Math.round(rating * 10) / 10).toFixed(1)}`;
			wrap.append(ratingEl);
		}

		const link = document.createElement("a");

		link.href = restaurantUrl(r);
		link.textContent = "View restaurant →";
		wrap.append(link);

		return wrap;
	}

	var $$exports = { ...$.legacy_api() };
	var div = root_4();
	var div_1 = $.child(div);
	let classes;

	$.bind_this(div_1, ($$value) => $.set(container, $$value), () => $.get(container));

	var node = $.sibling(div_1, 2);

	{
		var consequent = ($$anchor) => {
			var p = root();

			$.append($$anchor, p);
		};

		var consequent_1 = ($$anchor) => {
			var p_1 = root_1();

			$.append($$anchor, p_1);
		};

		var consequent_2 = ($$anchor) => {
			var p_2 = root_2();

			$.append($$anchor, p_2);
		};

		var consequent_3 = ($$anchor) => {
			var p_3 = root_3();

			$.append($$anchor, p_3);
		};

		$.add_svelte_meta(
			() => $.if(node, ($$render) => {
				if ($.strict_equals($.get(status), "loading")) $$render(consequent); else if ($.strict_equals($.get(status), "error")) $$render(consequent_1, 1); else if ($.strict_equals($.get(status), "unconfigured")) $$render(consequent_2, 2); else if ($.strict_equals($.get(located).length, 0)) $$render(consequent_3, 3);
			}),
			'if',
			MapView,
			109,
			2
		);
	}

	$.reset(div);
	$.template_effect(() => classes = $.set_class(div_1, 1, 'map-container svelte-19wauhf', null, classes, { hidden: $.strict_equals($.get(status), "ready", false) }));
	$.append($$anchor, div);

	return $.pop($$exports);
}